module.exports = __webpack_public_path__ + "static/media/illustration-lightbulb.aa4730e3.svg";